'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const collapsibleContent = require('./collapsible-content.cjs');
const collapsibleContext = require('./collapsible-context.cjs');
const collapsibleRoot = require('./collapsible-root.cjs');
const collapsibleRootProvider = require('./collapsible-root-provider.cjs');
const collapsibleTrigger = require('./collapsible-trigger.cjs');



exports.Content = collapsibleContent.CollapsibleContent;
exports.Context = collapsibleContext.CollapsibleContext;
exports.Root = collapsibleRoot.CollapsibleRoot;
exports.RootProvider = collapsibleRootProvider.CollapsibleRootProvider;
exports.Trigger = collapsibleTrigger.CollapsibleTrigger;
